import React, { Component, ReactNode } from 'react';

import ErrorBoundaryFallback from 'app/components/ErrorBoundaryFallback';
import { setDatadogProperty } from 'utils/datadog';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error) {
    this.setState({ hasError: true });
    setDatadogProperty('error', error.message);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
